<template>
  <div>

    <section>

      <h2> Please enter your company information </h2>

      <hr />

      <b-container class="bv-example-row">

        <b-row>

          <b-col cols="8">
            
            <b-form>

              <label><strong>Company Name</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.comp_name.$error }">
                <b-form-input
                  id="companynameinput"
                  name="companynameinput"
                  v-model.trim="comp_name" @input="$v.comp_name.$touch()"
                  :state="validateState('comp_name')"
                  aria-describedby="companyname-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="companyname-live-feedback"
                >Please enter a valid company name.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-2"><strong>Phone</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.phone.$error }">
                <b-input-group-prepend is-text>
                  <b-icon icon="telephone"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="phoneinput"
                  name="phoneinput"
                  type="text"
                  v-model.trim="phone" @input="$v.phone.$touch()"
                  :state="validateState('phone')"
                  aria-describedby="phone-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="phone-live-feedback"
                >Please enter a valid phone number.</b-form-invalid-feedback>
              </b-input-group>
              
              <label class="mt-2"><strong>Fax</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.fax.$error }">
                <b-input-group-prepend is-text>
                  <b-icon icon="file-earmark-text"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="faxinput"
                  name="faxinput"
                  type="text"
                  v-model.trim="fax" @input="$v.fax.$touch()"
                  :state="validateState('fax')"
                  aria-describedby="fax-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="phone-live-feedback"
                >Please enter a valid fax number.</b-form-invalid-feedback>
              </b-input-group>
              
              <label class="mt-2"><strong>Email</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.email.$error }">
                <b-input-group-prepend is-text>
                  <b-icon icon="envelope"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="emailinput"
                  name="emailinput"
                  type="email"
                  v-model.trim="email" @input="$v.email.$touch()"
                  :state="validateState('email')"
                  aria-describedby="email-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="email-live-feedback"
                >Please enter a valid email address.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-2"><strong>Address Line 1</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.addr_line1.$error }">
                <b-form-input
                  id="addrline1input"
                  name="addrline1input"
                  v-model.trim="addr_line1" @input="$v.addr_line1.$touch()"
                  :state="validateState('addr_line1')"
                  aria-describedby="addrline1-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="addrline1-live-feedback"
                >Please enter a valid address.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-2"><strong>Address Line 2</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.addr_line2.$error }">
                <b-form-input
                  id="addrline2input"
                  name="addrline2input"
                  v-model.trim="addr_line2" @input="$v.addr_line2.$touch()"
                  :state="validateState('addr_line2')"
                  aria-describedby="addrline2-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="addrline2-live-feedback"
                >Please enter a valid address.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-2"><strong>Country / State</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.countryandstate.$error }">
                <b-form-select
                  id="countryandstateinput"
                  name="countryandstateinput"
                  v-model="countryandstate" :options="options" @input="$v.countryandstate.$touch()" @change="getCountryAndState"
                  :state="validateState('countryandstate')"
                  aria-describedby="countryandstate-live-feedback"
                ></b-form-select>
                <b-form-invalid-feedback
                  id="countryandstate-live-feedback"
                >Please select a country and state.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-2"><strong>City</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.city.$error }">
                <b-form-input
                  id="cityinput"
                  name="cityinput"
                  v-model.trim="city" @input="$v.city.$touch()"
                  :state="validateState('city')"
                  aria-describedby="city-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="city-live-feedback"
                >Please enter a valid city.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-2"><strong>Postal / Zip</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.zip.$error }">
                <b-form-input
                  id="zipinput"
                  name="zipinput"
                  v-model.trim="zip" @input="$v.zip.$touch()"
                  :state="validateState('zip')"
                  aria-describedby="zip-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="zip-live-feedback"
                >Please enter a valid zip.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-2"><strong>Smartbilling Instance Name</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.subdomain.$error }">
                <b-form-input
                  id="subdomaininput"
                  name="subdomaininput"
                  v-model.trim="subdomain" @input="$v.subdomain.$touch()"
                  :state="validateState('subdomain')"
                  aria-describedby="subdomain-live-feedback"
                ></b-form-input>
                <b-input-group-prepend is-text>
                  <span id="basic-addon2">.smartbilling.ca</span>
                </b-input-group-prepend>
                <b-form-invalid-feedback
                  id="subdomain-live-feedback"
                >Please enter a valid instance name.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-2"><strong>Upload Your Company Logo</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.logofile.$error }">
                <b-form-file
                  id="logofileinput"
                  name="logofileinput"
                  type="file"
                  accept="image/jpeg, image/png, image/gif" 
                  @input="$v.logofile.$touch()" @change="onFileChange"
                  :state="validateState('logofile')"
                  aria-describedby="logofile-live-feedback"
                ></b-form-file>
                <b-form-invalid-feedback
                  id="logofile-live-feedback"
                >Please choose a valid company logo file.</b-form-invalid-feedback>
              </b-input-group>
              <div class="mt-2" v-if="logofile && ext_status">
                <b-img :src="logofile" fluid alt="The logo file should be .jpg, .png or .gif format."></b-img>
              </div>
              <div v-else-if="!ext_status">
                <small class="text-danger">Please choose a valid company logo file(.jpg, .png or .gif format).</small>
              </div>
            </b-form>

          </b-col>

          <b-col cols="4" class="container">
            <b-img :src="require('./assets/images/slide-03.png')" fluid alt="smartbox smartbilling"></b-img>
          </b-col>
      
        </b-row>
  
      </b-container>
  
    </section>

  </div>

</template>

<script>

const { required, email, minLength, maxLength, requiredIf } = require('vuelidate/lib/validators')
const { default: Vuelidate } = require('vuelidate')
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue'
import BIcon from 'bootstrap-vue'
import { helpers } from 'vuelidate/lib/validators'
import axios from 'axios' 

const OnlyDigits = helpers.regex('onlyDigits', /^\d+$/);
const phonereg = helpers.regex('phonereg', /^[0-9 -]*$/);
const alpha = helpers.regex('alpha', /^[a-zA-Z0-9]*$/)
const alphablank = helpers.regex('alpha', /^[a-zA-Z0-9 ]*$/)
const imageRule = helpers.regex('imageRule', /\.(gif|jpeg|jpg|png)$/)

export default {
  name: 'StepCompany',
  data() {
    return {
      comp_name: '',
      phone: '',
      fax: '',
      email: '',
      lang_code: null, 
      crcy_code: null,
      addr_line1: '',
      addr_line2: '',
      country: '',
      state: '',
      countryandstate: null,
      state_id: null,
      city: '',
      zip: '',
      subdomain: '',
      logofile: null,
      upload_image_src: {},
      options: this.$countrystateoptions,
      statelist: null,
      ext_status: true,
      forclearlyip: false,
      currentUrl: location.toString(),
    }
  },
  mounted() {
    //alert(process.env.NODE_ENV);
    //console.log('NODE_ENV is:'+process.env.NODE_ENV);
    //console.log('VUE_APP_UPLOAD_URL is:'+process.env.VUE_APP_UPLOAD_URL);
    this.forclearlyip = this.currentUrl.includes("clearlyip");
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
    
    //console.log(this.$stateURL);

    axios.post(this.$stateURL, {
      headers: headers
      })      
      .then(response => {
        //console.log(response.data);
        if (response.data['error'] == false) {
        }
        else {
          this.$statelist = response.data;
          //console.log(this.$statelist);
                    
          this.$statelist.forEach((value, index) => {
            
            var $newvalue;

            if (value.ctry_id == '1') {
            
              $newvalue = { 'value' : { 'country': 'Canada', 'state': value.state_name }, 'text': value.state_name };
              
              this.options[1].options.push($newvalue);

            } else if (value.ctry_id == '2') {
            
              $newvalue = { 'value' : { 'country': 'United States', 'state': value.state_name }, 'text': value.state_name };

              this.options[2].options.push($newvalue);

            } else if (value.ctry_id == '82') {
              
              $newvalue = { 'value' : { 'country': 'Ireland', 'state': value.state_name }, 'text': value.state_name };

              this.options[3].options.push($newvalue);

            }
          });
          
          //console.log(this.options);
        }
      })
      .catch(error => {
        alert("Country and state info process error!")
        console.error("There was an error!", error);
      });


  },
  validations: {
    comp_name: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(30)
    },
    phone: {
      required,
      phonereg,
      minLength: minLength(10),
      maxLength: maxLength(20)      
    },
    fax: {
      //required,
      phonereg,
      minLength: minLength(10),
      maxLength: maxLength(20)      
    },
    email: {
      required,
      email
    },
    lang_code: {
      required
    },
    crcy_code: {
      required
    },        
    addr_line1: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)      
    },
    addr_line2: {
      
    },
    countryandstate: {
      required
    },
    city: {
      required
    },
    zip: {
      required,
      alphablank
    },      
    subdomain: {
      required,
      alpha,
      minLength: minLength(3),
      maxLength: maxLength(20)
    },                      
    logofile: {
         
    },
    form: ['comp_name', 'email', 'lang_code', 'crcy_code', 'phone', 'fax', 'addr_line1', 'addr_line2', 'countryandstate', 'city', 'zip', 'subdomain', 'logofile']
  },
  methods: {
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },    
    onFileChange(e) {
      this.ext_status = true;
      const file = e.target.files[0];
      //console.log(file.name);
      var filename = file.name.split(".");
      var ext = filename[1].toLowerCase();
      //console.log(ext);

      if ( ext != 'jpg' && ext != 'jpeg' && ext != 'png' && ext != 'gif') {
        this.ext_status = false;
        return;
      }
      
      this.logofile = URL.createObjectURL(file);
      //console.log(this.logofile);

      let updata = new FormData();

      updata.append('file', file);

      let upconfig = {
        header : {
          'Content-Type' : 'image/png'
        }
      }

      axios.post(
        this.$uploadURL, 
        updata,
        upconfig
      )
      .then(response => {
        //alert("Sucess!")
        //console.log(response.data);
        this.upload_image_src = { 'changingThisBreaksApplicationSecurity' : response.data.image };
        //console.log(this.upload_image_src)
      })
      .catch(error => {
        alert("logo file process error!")
        this.errorMessage = error.message;
        //alert(this.errorMessage);
        console.error("There was an error!", error);
      });
      
    },
    getCountryAndState() {
      this.country = this.countryandstate.country
      this.state = this.countryandstate.state
      
      switch(this.country) {
        case 'Canada':
          if ( this.state == 'Quebec' && !this.forclearlyip ) {
            this.lang_code = this.$french_lang_code              
          }
          else {
            this.lang_code = this.$default_lang_code              
          }
          this.crcy_code = this.$canada_crcy_code
          break;
        case 'United States':
          this.lang_code = this.$default_lang_code
          this.crcy_code = this.$usa_crcy_code
          break;
        case 'Ireland':
          this.lang_code = this.$default_lang_code
          this.crcy_code = this.$eur_crcy_code
          break;                        
        default:
          break;
      }
      
      this.$statelist.forEach((value, index) => {
        if (value.state_name == this.state) {
          this.state_id = value;
        } 
      });
 
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/StepCompany.vue